import $ajax from './../script/ajax'
import { user } from '../config/apis'

export default {
  /**
   * @2019-10-17
   * @author: huimingchen
   * desc: 用户登录
   */
  login: (params, options) => {
    return $ajax(Object.assign({ ...user.login, data: params }, options))
  },
  menu: (params, options) => {
    return $ajax(Object.assign({ ...user.menu, data: params }, options))
  },
  providerInfo: (params, options) => {
    return $ajax(Object.assign({ ...user.providerInfo, data: params }, options))
  },
  outsourceInfo: (params, options) => {
    return $ajax(Object.assign({ ...user.outsourceInfo, data: params }, options))
  },
  //获取用户信息接口
  userInfo: (params, options) => {
    return $ajax(Object.assign({ ...user.userInfo, data: params }, options))
  },
  //外包商注册
  outsourceRegister: (params, options) => {
    return $ajax(Object.assign({ ...user.outsourceRegister, data: params }, options))
  },
  checkoutCode: (params, options) => {
    return $ajax(Object.assign({ ...user.checkoutCode, data: params }, options))
  },
  updatePassword: (params, options) => {
    return $ajax(Object.assign({ ...user.updatePassword, data: params }, options))
  }
}



// WEBPACK FOOTER //
// ./src/apis/user.js